const SkeletonCard = () => {
  return (
    <div className="w-full flex flex-col max-w-xs p-4 bg-white border rounded-xl shadow-sm animate-pulse">
      <div className="flex justify-between items-start">
        <div className="flex gap-3">
          <div className="h-10 w-10 bg-gray-300 rounded" />
          <div>
            <div className="h-4 w-32 bg-gray-300 rounded mb-2" />
            <div className="h-3 w-24 bg-gray-200 rounded" />
          </div>
        </div>
        <div className="h-10 w-10 bg-gray-200 rounded" />
      </div>

      <div className="h-4 bg-gray-300 rounded mt-4 w-3/4" />
      <div className="space-y-2 mt-3">
        <div className="h-3 bg-gray-200 rounded" />
        <div className="h-3 bg-gray-200 rounded w-5/6" />
      </div>

      <div className="h-10 bg-gray-200 rounded mt-auto" />
    </div>
  );
};

export default SkeletonCard;
